import React from "react";
import {Breadcrumb, Button, Input, Layout, Menu} from "antd";
import {
    PoweroffOutlined,
} from '@ant-design/icons';
import './Profile.less';
import PageHeader from "../views/PageHeader";
import Div from "../views/Div";

export default class Profile extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            leftRouterState: false,
        };
    }

    render() {
        return (
            <div className='Profile'>
                <PageHeader title='Мой профиль'/>
                <Div>
                    <Button className='exit' icon={<PoweroffOutlined/>} onClick={this.onExit}>Выйти</Button>
                </Div>
            </div>
        );
    }

    onExit = () => {
        window.logout();
    }
}